module.exports = __webpack_public_path__ + "img/icons-chair_d.2883ec87.png";